<div class="wrapper">
  <div class="head">
    <reb-ngx-label mood="none" size="22" weight="500"> Pending Activations ({{collectionOfPendingCompanies.length}})</reb-ngx-label>
  </div>
  <div *ngIf="hasMessage" class="banner-wrapper">
    <reb-ngx-banner size="14" mood="error" message="There was a problem when trying to list your pending activations."></reb-ngx-banner>
  </div>
  <div *ngIf="!hasMessage" class="content">
    <reb-ngx-listable-card class="size size1of1" borderRadius="lg" borderWidth="xs" shadow="none" width=auto
      [collection]="collectionOfPendingCompanies" [useDivider]="true" [itemTemplate]="itemTemplate">
      <ng-template let-item #itemTemplate>
        <reb-ngx-card borderRadius="lg" borderWidth="none" paddingHorizontal="16" paddingVertical="24"
          bodyPaddingHorizontal="none" bodyPaddingVertical="none" [showHeader]="false" shadow="none" width="auto">
          <div class="card-body-content" style="display: flex; flex-direction: row; justify-content: space-between;">
            <div style="display: flex; flex-direction: column;">
              <reb-ngx-label size="16" weight="500" mood="info" style="display: flex;">{{item.name}}</reb-ngx-label>
              <reb-ngx-label size="12" weight="400" mood="none">Request on: {{item.createdAt | dateTz:'medium'
                }}</reb-ngx-label>
            </div>
            <reb-ngx-mat-button 
                [disabled]="item.status === _companyStatus.pending" 
                iconSize="small" 
                kind="primary" 
                size="small" 
                type="button"
                (clickHandler)="activateCompany(item)">Activate</reb-ngx-mat-button>
          </div>
        </reb-ngx-card>
      </ng-template>
    </reb-ngx-listable-card>
  </div>
</div>
